import {createSelector} from 'reselect';

import type {NutshellState} from '../../../store';

import {getUIState} from '../../ui-selectors';

const getGlossaryState = createSelector([getUIState], (uiState) => uiState.glossary);

export const getGlossaryKey = (state: NutshellState) => {
    return getGlossaryState(state).glossaryKey;
};

export const getIsButtonExpanded = (state: NutshellState) => {
    return getGlossaryState(state).isButtonExpanded;
};
